import {
  styled, rem
} from 'config/stitches.config'

export const StyledContentWithSliderContent = styled('div', {
  display: 'grid',
  gap: rem(64),
  gridTemplateAreas: `
    "content"
    "carousel"
  `,
  '@lg': {
    gridTemplateColumns: 'repeat(2, 1fr)',
    gridTemplateAreas: `
      "content carousel"
  `,
  },
  variants: { disposition: { left: { '@lg': { gridTemplateAreas: '" carousel content"', } }, }, }
})

export const StyledContentWithSliderCarousel = styled('div', { 'gridArea': 'carousel' })
